import BackendRepositoryRemote from '../api/BackendRepositoryRemote';
import { BackendRepository } from '../api/interfaces/BackendRepository';
import { generateSignedPostPayload } from './Aws';

export interface UploadMeterkastPhotosParams {
  customerEmail: string;
  customerId: string;
  hashId: string;
  jwt: string;
  photos: File[];
}

const generateUniqueName = (): string => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return `${crypto.randomUUID()}.jpg`;
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}.jpg`;
};

export default class MeterkastService {
  private repository: BackendRepository;

  constructor() {
    this.repository = new BackendRepositoryRemote();
  }

  public async uploadPhotos({
    jwt,
    photos,
  }: UploadMeterkastPhotosParams): Promise<void> {
    const imageNames = photos.map(() => generateUniqueName());

    const uploads = await this.repository.meterkastPresign(
      { imageNames },
      jwt,
    );

    await Promise.all(
      uploads.map((upload) => {
        const file = photos[imageNames.indexOf(upload.imageName)];
        const body = generateSignedPostPayload({ ...upload.fields, file });

        return this.repository.uploadMeterkastImage({ url: upload.url, body });
      }),
    );

    await this.repository.meterkastConfirm(jwt);
  }
}
